import Lead from './Lead';

export default Lead;
